<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12"> Non autorizzato 1 </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Nonfound',
}
</script>
